<template>
    <section >
    <div class="pt-40 pb-60 mb-40">
        <h2 class="text-24 fw-600 mb-40"> {{ $t('curriculum.title2') }}</h2>
        <div class="row">
            <div class="col-lg-6" v-for="schedule in formattedDates" :key="schedule.id">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">{{ schedule.title }}</h5>
                        <p class="card-text">{{ schedule.description }}</p>
                        <ul class="list-unstyled">
                           <!--  <li>
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                        fill="none">
                                        <path
                                            d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2ZM10 4C10.2449 4.00003 10.4813 4.08996 10.6644 4.25272C10.8474 4.41547 10.9643 4.63975 10.993 4.883L11 5V9.586L13.707 12.293C13.8863 12.473 13.9905 12.7144 13.9982 12.9684C14.006 13.2223 13.9168 13.4697 13.7488 13.6603C13.5807 13.8508 13.3464 13.9703 13.0935 13.9944C12.8406 14.0185 12.588 13.9454 12.387 13.79L12.293 13.707L9.293 10.707C9.13758 10.5514 9.03776 10.349 9.009 10.131L9 10V5C9 4.73478 9.10536 4.48043 9.29289 4.29289C9.48043 4.10536 9.73478 4 10 4Z"
                                            fill="#062B3B" />
                                    </svg>
                                </span>
                                <span>{{ $t('labels.time') }} :</span>
                                <span class="d-inline-flex gap-3"> <span>{{ $t('from') }}</span> {{ schedule['start_date'].time }} <span> {{ $t('to') }} </span> {{ schedule['end_date'].time }}</span>
			   </li> -->
                            <li class="flex-wrap align-items-start">
                                <span class="d-flex gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                        fill="none">
                                        <path
                                            d="M17.202 2.13318H15.0308V0.558662C15.0308 0.268327 14.7734 -0.0108426 14.4712 0.000324132C14.169 0.0114909 13.9116 0.245993 13.9116 0.558662V2.13318H6.07722V0.558662C6.07722 0.268327 5.81981 -0.0108426 5.51763 0.000324132C5.21545 0.0114909 4.95803 0.245993 4.95803 0.558662V2.13318H2.79799C2.05591 2.13318 1.34424 2.4273 0.819511 2.95084C0.294787 3.47439 0 4.18446 0 4.92487V17.2083C0 17.9487 0.294787 18.6588 0.819511 19.1823C1.34424 19.7059 2.05591 20 2.79799 20H17.202C17.9441 20 18.6558 19.7059 19.1805 19.1823C19.7052 18.6588 20 17.9487 20 17.2083V4.92487C20 4.18446 19.7052 3.47439 19.1805 2.95084C18.6558 2.4273 17.9441 2.13318 17.202 2.13318ZM18.8808 17.2083C18.8808 18.1352 18.1309 18.8833 17.202 18.8833H2.79799C1.86905 18.8833 1.11919 18.1352 1.11919 17.2083V7.80589H18.8808V17.2083ZM18.8808 6.68922H1.11919V4.92487C1.11919 3.99803 1.86905 3.24985 2.79799 3.24985H4.95803V3.90869C4.95803 4.19903 5.21545 4.4782 5.51763 4.46703C5.81981 4.45586 6.07722 4.22136 6.07722 3.90869V3.24985H13.9116V3.90869C13.9116 4.19903 14.169 4.4782 14.4712 4.46703C14.7734 4.45586 15.0308 4.22136 15.0308 3.90869V3.24985H17.202C18.1309 3.24985 18.8808 3.99803 18.8808 4.92487V6.68922Z"
                                            fill="#062B3B" />
                                    </svg>
				    <span>{{ $t('labels.end_date') }} :</span>
                                </span>
                                
                                <span class="d-inline-flex gap-2" style="color: black; font-weight: 400;"> {{ schedule['start_date'].date }} <span> {{ $t('to') }} </span> {{ schedule['end_date'].date }} </span>
                            </li>
                            <li>
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18"
                                        fill="none">
                                        <path
                                            d="M15 4.46885V1.38462C15 1.01739 14.8244 0.66521 14.5118 0.405544C14.1993 0.145879 13.7754 0 13.3333 0H1.66667C1.22464 0 0.800716 0.145879 0.488155 0.405544C0.175595 0.66521 0 1.01739 0 1.38462V4.5C0.00056301 4.71487 0.061052 4.92671 0.176721 5.1189C0.292389 5.31109 0.460091 5.47839 0.666667 5.60769L6.11146 9L0.666667 12.3923C0.460091 12.5216 0.292389 12.6889 0.176721 12.8811C0.061052 13.0733 0.00056301 13.2851 0 13.5V16.6154C0 16.9826 0.175595 17.3348 0.488155 17.5945C0.800716 17.8541 1.22464 18 1.66667 18H13.3333C13.7754 18 14.1993 17.8541 14.5118 17.5945C14.8244 17.3348 15 16.9826 15 16.6154V13.5312C14.9994 13.3171 14.9394 13.1061 14.8247 12.9144C14.71 12.7227 14.5436 12.5556 14.3385 12.4261L8.88229 9L14.3385 5.57308C14.5437 5.44378 14.7102 5.27684 14.8249 5.0853C14.9396 4.89376 14.9996 4.68279 15 4.46885ZM13.3333 16.6154H1.66667V13.5L7.5 9.86538L13.3333 13.5303V16.6154ZM13.3333 4.46885L7.5 8.13461L1.66667 4.5V1.38462H13.3333V4.46885Z"
                                            fill="#062B3B" />
                                    </svg>
                                </span>
                                <span>{{ $t('labels.price') }} :</span>
                                <span> {{ schedule.price.price }} {{ schedule.price.currency }} </span>
                            </li>
                        </ul>

                    </div>
                </div>

            </div>

        </div>
    </div>
    </section>
</template>
<script>
export default {
    data() {
        return {
            formattedDates: [],
        }
    },
    computed: {
        courseItem() {
            return this.$store.getters.courseItem;
        },
        formattedDates() {
            // Map over the API data to format dates and times
            return this.courseItem.schedules.map((item) => ({
                id: item.id,
                title: item.title,
                description: item.description,
                price: item.price,
                start_date: this.extractDateTime(item.start_date),
                end_date: this.extractDateTime(item.end_date),
            }))
        }
    },
    methods: {
        extractDateTime(isoString) {
            const date = new Date(isoString);
            const extractedDate = date.toISOString().split('T')[0]; // Extract date (YYYY-MM-DD)
            const extractedTime = date.toTimeString().split(' ')[0]; // Extract time (HH:MM:SS)
            return { date: extractedDate, time: extractedTime };
        },

    }
}
</script>
<style lang="scss" scoped>
*{
    &:lang(en) {
        font-family: "poppins", sans-serif !important;
    }

    &:lang(ar) {
        font-family: "Almarai", serif !important;
    }
}
.card{
    border-radius: 8px;
    background: var(--Gray-White, #FFF);
    box-shadow: 0px 3px 12px 0px #4b4b4b26;
    border: transparent;
    padding: 28px 10px;
}
.card-title{
    color: var(--Primary-700, #062B3B);
    font-size: 20px;
    font-weight: 600;
    line-height: 1.4; 
}
.card-text{
    color: #333;
    margin-bottom: 15px;
    margin-top: 10px;
    font-size: 18px;
    font-weight: 400;
    line-height: 140%; 
}
    ul li{
       display: inline-flex;
       align-items: center;
       gap: 10px;
        margin-top: 18px;
        font-size: 14px;
         span:nth-child(2){
            color: var(--Primary-700, #0a5270);
            font-weight: 600;
        }
    span:last-of-type{
        display: block;
        text-align: right;
    }
    }
</style>
